(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirecde7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirecde7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iE7OH", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf; }, function (v) { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf = v; });
var $0380ce8f1f064ccc$export$6503ec6e8aabbaf;
var $0380ce8f1f064ccc$export$f7ad0328861e2f03;
"use strict";
var $0380ce8f1f064ccc$var$mapping = new Map();
function $0380ce8f1f064ccc$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0380ce8f1f064ccc$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0380ce8f1f064ccc$var$resolve(id) {
    var resolved = $0380ce8f1f064ccc$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0380ce8f1f064ccc$export$6503ec6e8aabbaf = $0380ce8f1f064ccc$var$register;
$0380ce8f1f064ccc$export$f7ad0328861e2f03 = $0380ce8f1f064ccc$var$resolve;

});

parcelRegister("aNJCr", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $7dd1ddf6834435ca$export$bdfd709ae4826697; }, function (v) { return $7dd1ddf6834435ca$export$bdfd709ae4826697 = v; });
var $7dd1ddf6834435ca$export$bdfd709ae4826697;
var $7dd1ddf6834435ca$export$c9e73fbda7da57b6;
var $7dd1ddf6834435ca$export$5a759dc7a1cfb72a;
"use strict";
var $7dd1ddf6834435ca$var$bundleURL = {};
function $7dd1ddf6834435ca$var$getBundleURLCached(id) {
    var value = $7dd1ddf6834435ca$var$bundleURL[id];
    if (!value) {
        value = $7dd1ddf6834435ca$var$getBundleURL();
        $7dd1ddf6834435ca$var$bundleURL[id] = value;
    }
    return value;
}
function $7dd1ddf6834435ca$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $7dd1ddf6834435ca$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $7dd1ddf6834435ca$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $7dd1ddf6834435ca$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$7dd1ddf6834435ca$export$bdfd709ae4826697 = $7dd1ddf6834435ca$var$getBundleURLCached;
$7dd1ddf6834435ca$export$c9e73fbda7da57b6 = $7dd1ddf6834435ca$var$getBaseURL;
$7dd1ddf6834435ca$export$5a759dc7a1cfb72a = $7dd1ddf6834435ca$var$getOrigin;

});

var $eb04b958d9fa65b2$exports = {};


(parcelRequire("iE7OH")).register((parcelRequire("aNJCr")).getBundleURL("bu0dN"), JSON.parse('["bu0dN","index.d5048b8f.js","32JkH","digital.f12f83cd.jpg","cd377","grow.f0f64dd7.jpg","ms21W","card.f075fa3f.jpg"]'));

var $3895bd3d8fb2dc40$exports = {};

$3895bd3d8fb2dc40$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "digital.f12f83cd.jpg";


var $619650b831c50cc8$exports = {};

$619650b831c50cc8$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "grow.f0f64dd7.jpg";


var $5db11133b7f4f1c1$exports = {};

$5db11133b7f4f1c1$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "card.f075fa3f.jpg";


const $66b821ea461d9f2a$var$modal = document.querySelector(".modal");
const $66b821ea461d9f2a$var$overlay = document.querySelector(".overlay");
const $66b821ea461d9f2a$var$btnCloseModal = document.querySelector(".btn--close-modal");
const $66b821ea461d9f2a$var$btnsOpenModal = document.querySelectorAll(".btn--show-modal");
const $66b821ea461d9f2a$var$btnScrollTo = document.querySelector(".btn--scroll-to");
const $66b821ea461d9f2a$var$section1 = document.querySelector("#section--1");
const $66b821ea461d9f2a$var$nav = document.querySelector(".nav");
const $66b821ea461d9f2a$var$tabs = document.querySelectorAll(".operations__tab");
const $66b821ea461d9f2a$var$tabsContainer = document.querySelector(".operations__tab-container");
const $66b821ea461d9f2a$var$tabsContent = document.querySelectorAll(".operations__content");
// Modal window
const $66b821ea461d9f2a$var$openModal = function(e) {
    e.preventDefault();
    $66b821ea461d9f2a$var$modal.classList.remove("hidden");
    $66b821ea461d9f2a$var$overlay.classList.remove("hidden");
};
const $66b821ea461d9f2a$var$closeModal = function() {
    $66b821ea461d9f2a$var$modal.classList.add("hidden");
    $66b821ea461d9f2a$var$overlay.classList.add("hidden");
};
$66b821ea461d9f2a$var$btnsOpenModal.forEach((btn)=>btn.addEventListener("click", $66b821ea461d9f2a$var$openModal));
$66b821ea461d9f2a$var$btnCloseModal.addEventListener("click", $66b821ea461d9f2a$var$closeModal);
$66b821ea461d9f2a$var$overlay.addEventListener("click", $66b821ea461d9f2a$var$closeModal);
document.addEventListener("keydown", function(e) {
    if (e.key === "Escape" && !$66b821ea461d9f2a$var$modal.classList.contains("hidden")) $66b821ea461d9f2a$var$closeModal();
});
// Button scrolling
$66b821ea461d9f2a$var$btnScrollTo.addEventListener("click", function(e) {
    e.preventDefault();
    const options = {
        behavior: "smooth",
        block: "start",
        inline: "nearest"
    };
    const offset = 1 * parseFloat(getComputedStyle(document.documentElement).fontSize);
    $66b821ea461d9f2a$var$section1.style.transform = `translateY(${offset}px)`;
    $66b821ea461d9f2a$var$section1.scrollIntoView(options);
});
// Page navigation
document.querySelector(".nav__links").addEventListener("click", function(e) {
    if (e.target.classList.contains("nav__link")) {
        e.preventDefault();
        const id = e.target.getAttribute("href");
        const targetElement = document.querySelector(id);
        let offset = 1 * parseFloat(getComputedStyle(document.documentElement).fontSize);
        const options = {
            behavior: "smooth",
            block: "start",
            inline: "nearest"
        };
        targetElement.style.transform = `translateY(${offset}px)`;
        targetElement.scrollIntoView(options);
        // Clean up the transformation after scrolling
        targetElement.addEventListener("scrollend", function cleanup() {
            targetElement.style.transform = "none";
            targetElement.removeEventListener("scrollend", cleanup);
        });
    }
});
// Tabbed Component
$66b821ea461d9f2a$var$tabsContainer.addEventListener("click", function(e) {
    const clicked = e.target.closest(".operations__tab");
    if (!clicked) return;
    $66b821ea461d9f2a$var$tabs.forEach((t)=>t.classList.remove("operations__tab--active"));
    $66b821ea461d9f2a$var$tabsContent.forEach((c)=>c.classList.remove("operations__content--active"));
    // Active Tab
    clicked.classList.add("operations__tab--active");
    // Activate content area
    document.querySelector(`.operations__content--${clicked.dataset.tab}`).classList.add("operations__content--active");
});
// Menu Fade Animation
const $66b821ea461d9f2a$var$handleHover = function(e) {
    if (e.target.classList.contains("nav__link")) {
        const link = e.target;
        const siblings = link.closest(".nav").querySelectorAll(".nav__link");
        const logo = link.closest(".nav").querySelector("img");
        siblings.forEach((el)=>{
            if (el !== link) el.style.opacity = this;
        });
        logo.style.opacity = this;
    }
};
$66b821ea461d9f2a$var$nav.addEventListener("mouseover", $66b821ea461d9f2a$var$handleHover.bind(0.5));
$66b821ea461d9f2a$var$nav.addEventListener("mouseout", $66b821ea461d9f2a$var$handleHover.bind(1));
// Sticky Nav using Intersection Observer API
const $66b821ea461d9f2a$var$header = document.querySelector(".header");
const $66b821ea461d9f2a$var$navHeight = $66b821ea461d9f2a$var$nav.getBoundingClientRect().height;
const $66b821ea461d9f2a$var$stickyNav = function(entries) {
    const [entry] = entries;
    if (!entry.isIntersecting) $66b821ea461d9f2a$var$nav.classList.add("sticky");
    else $66b821ea461d9f2a$var$nav.classList.remove("sticky");
};
const $66b821ea461d9f2a$var$headerObserver = new IntersectionObserver($66b821ea461d9f2a$var$stickyNav, {
    root: null,
    threshold: 0,
    rootMargin: `-${$66b821ea461d9f2a$var$navHeight}px`
});
$66b821ea461d9f2a$var$headerObserver.observe($66b821ea461d9f2a$var$header);
// Reveal sections
const $66b821ea461d9f2a$var$allSections = document.querySelectorAll(".section");
const $66b821ea461d9f2a$var$revealSection = function(entries, observer) {
    const [entry] = entries;
    if (!entry.isIntersecting) return;
    entry.target.classList.remove("section--hidden");
    observer.unobserve(entry.target);
};
const $66b821ea461d9f2a$var$sectionObserver = new IntersectionObserver($66b821ea461d9f2a$var$revealSection, {
    root: null,
    threshold: 0.15
});
$66b821ea461d9f2a$var$allSections.forEach(function(section) {
    $66b821ea461d9f2a$var$sectionObserver.observe(section);
    section.classList.add("section--hidden");
});
const $66b821ea461d9f2a$var$imgTargets = document.querySelectorAll(".features__img");
const $66b821ea461d9f2a$var$loadImg = function(entries, observer) {
    const [entry] = entries;
    if (!entry.isIntersecting) return;
    // Get the value of data-my-variable attribute
    const imageName = entry.target.getAttribute("data-my-variable");
    // Determine the image source based on the value of data-my-variable
    let newSrc;
    switch(imageName){
        case "digital":
            newSrc = (0, (/*@__PURE__*/$parcel$interopDefault($3895bd3d8fb2dc40$exports)));
            break;
        case "grow":
            newSrc = (0, (/*@__PURE__*/$parcel$interopDefault($619650b831c50cc8$exports)));
            break;
        case "card":
            newSrc = (0, (/*@__PURE__*/$parcel$interopDefault($5db11133b7f4f1c1$exports)));
            break;
        default:
            newSrc = (0, (/*@__PURE__*/$parcel$interopDefault($3895bd3d8fb2dc40$exports))); // Default to digital image if no match found
    }
    // Replace src with the new image source
    entry.target.src = newSrc;
    // Remove lazy-img class after the new image is loaded
    entry.target.addEventListener("load", function() {
        entry.target.classList.remove("lazy-img");
    });
    // Stop observing the current target once the image is loaded
    observer.unobserve(entry.target);
};
const $66b821ea461d9f2a$var$imgObserver = new IntersectionObserver($66b821ea461d9f2a$var$loadImg, {
    root: null,
    threshold: 0,
    rootMargin: "200px"
});
$66b821ea461d9f2a$var$imgTargets.forEach((img)=>$66b821ea461d9f2a$var$imgObserver.observe(img));
// Slider
const $66b821ea461d9f2a$var$slider = function() {
    const slides = document.querySelectorAll(".slide");
    const btnLeft = document.querySelector(".slider__btn--left");
    const btnRight = document.querySelector(".slider__btn--right");
    let curSlide = 0;
    const maxSlide = slides.length;
    const dotContainer = document.querySelector(".dots");
    // Slider Functions:
    const createDots = function() {
        slides.forEach(function(_, i) {
            dotContainer.insertAdjacentHTML("beforeend", `<button class="dots__dot" data-slide="${i}"></button>`);
        });
    };
    // Style Dots
    const activateDot = function(slide) {
        document.querySelectorAll(".dots__dot").forEach((dot)=>dot.classList.remove("dots__dot--active"));
        document.querySelector(`.dots__dot[data-slide="${slide}"]`).classList.add("dots__dot--active");
    };
    // Slider Movement
    const goToSlide = function(slide) {
        slides.forEach((s, i)=>s.style.transform = `translateX(${100 * (i - slide)}%)`);
    };
    // Next Slide
    const nextSlide = function() {
        if (curSlide === maxSlide - 1) curSlide = 0;
        else curSlide++;
        goToSlide(curSlide);
        activateDot(curSlide);
    };
    // Prev Slide
    const prevSlide = function() {
        if (curSlide === 0) curSlide = maxSlide - 1;
        else curSlide--;
        goToSlide(curSlide);
        activateDot(curSlide);
    };
    const init = function() {
        goToSlide(0);
        createDots();
        activateDot(0);
    };
    init();
    // Event Handlers
    btnRight.addEventListener("click", nextSlide);
    btnLeft.addEventListener("click", prevSlide);
    // Keyboard functionality of slider
    document.addEventListener("keydown", function(e) {
        if (e.key === "ArrowLeft") prevSlide();
        if (e.key === "ArrowRight") nextSlide();
    });
    // Dot handler
    dotContainer.addEventListener("click", function(e) {
        if (e.target.classList.contains("dots__dot")) {
            const { slide: slide } = e.target.dataset;
            goToSlide(slide);
            activateDot(slide);
        }
    });
};
$66b821ea461d9f2a$var$slider();

})();
//# sourceMappingURL=index.d5048b8f.js.map
